import React from 'react';

import { Button } from '@vimeo/bokeh';

interface Props {
  text: string;
  link: string;
  variant?: string;
  format?: string;
  onClick?: VoidFunction;
}

const CustomCTAButton = (props: Props) => {
  return (
    <Button
      data-testid="upsell-cta"
      onClick={props.onClick}
      as="a"
      target="_blank"
      w="100%"
      href={props.link}
      size="md"
      variant={props.variant}
    >
      {props.text}
    </Button>
  );
};

export default CustomCTAButton;
